<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="receivings">
        <dx-data-grid
            #dataGrid
            [dataSource]="receivings"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="poNumberDisplay" caption="PO #" width="80"></dxi-column>
            <dxi-column dataField="vendorDisplay" caption="Vendor" width="200"></dxi-column>
            <dxi-column dataField="purchaseOrderLine.partNumber" caption="Part #" width="180"></dxi-column>
            <dxi-column dataField="purchaseOrderLine.description" caption="Description" width="180"></dxi-column>

            <dxi-column dataField="quantity" width="80"></dxi-column>
            <dxi-column dataField="purchaseOrderLine.cost" caption="Cost" width="80" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="lineTotal" caption="Est. Total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>

            <dxi-column dataField="created" caption="Created" width="100"></dxi-column>
            <dxi-column dataField="purchaseOrderLine.part.mfgPartNumber" caption="Mfg. Part" width="100"></dxi-column>
            <dxi-column dataField="purchaseOrderLine.purchaseOrder.vendor.quickBooksId" caption="Vendor QBID" width="200"></dxi-column>
            <dxi-column dataField="deleted" width="100"></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="purchase-order-receivings-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success ms-2" (click)="createBill(false)" [hidden]="!canCreateBills" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                    Create Bill
                </button>
                <button class="btn btn-secondary ms-2" (click)="payWithoutQuickBooks()" [hidden]="!canCreateBills" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                    Pay w/o Quickbooks
                </button>
                <button
                    class="btn btn-danger ms-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || dataGrid.instance.getSelectedRowsData()[0].quickBooksId !== null"
                    [hidden]="!auth.hasRole('Administrator')"
                >
                    Delete
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="receivings" class="me-3"
                    ><strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong></span
                >
            </div>

            <div *dxTemplate="let data of 'toolbarTextBefore'">
                <span *ngIf="receivings" class="ms-3"
                    ><strong>
                        Selected Amount:
                        {{ selectedTotal | currency }}
                    </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
